module.exports = __webpack_public_path__ + "assets/img/paddlefloat.83fa7a85.png";